(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.menuList
   */
  angular
    .module("akitabox.mobile.directives.menuList", [])
    .directive("abmMenuList", AbmMenuListDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.menuList
   * @name AbmMenuListDirective
   *
   * @restrict E
   *
   * @description
   * `<abm-menu-list>` is a list container with title header (icon and text) for 1..n `<md-list-item>` and
   * `<md-subheader>` elements. It also allows the user to specify an optional click action for the title header.
   *
   * @usage
   * <hljs lang="html">
   * <abm-menu-list title="Buildings" icon="location_city" ng-click="vm.goToBuildings()">
   *   <md-subheader>Recent</md-subheader>
   *   <md-list-item ng-repeat="bldg in vm.recentBuildings | limitTo:3" ng-click="vm.selectBuilding(bldg)">
   *     <p md-truncate ng-bind="bldg.name"></p>
   *     <md-icon class="material-icons md-accent">arrow_forward</md-icon>
   *   </md-list-item>
   * </abm-menu-list>
   * </hljs>
   */
  function AbmMenuListDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/menu-list/menu-list.html",
      transclude: true,
      link: postLink,
      scope: {
        icon: "@",
        title: "@",
        ngClick: "&?",
      },
    };

    function postLink($scope, $element, attrs) {
      $scope.hasClick = angular.isDefined(attrs.ngClick);
    }
  }
})();
